export default __webpack_public_path__ + "static/media/resume.1cdbd630.jpg";